module.exports = __webpack_public_path__ + "media/images/logos/workday-84dc717b1d23d62cbe96124502c4ef86.png";